import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'


import VueAgile from 'vue-agile'

Vue.use(VueAgile)


import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

import sidebar from './components/sidebar.vue';
Vue.component('sidebar', sidebar);

import navbar  from './components/navbar.vue';
Vue.component('navbar', navbar);

import logo_header   from './components/logo_header.vue';
Vue.component('logo_header', logo_header);

import foother from './components/foother.vue';
Vue.component('foother', foother);

import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'http://silada.konaweselatankab.go.id/assets/css/bg.css',
    'http://silada.konaweselatankab.go.id/assets/css/huruf.css',
    'http://silada.konaweselatankab.go.id/assets/css/kiken.css',
    'http://silada.konaweselatankab.go.id/assets/css/table.css',
    'https://fonts.googleapis.com/css?family=Oswald',
    'https://fonts.googleapis.com/css?family=Dancing+Script',
    'https://fonts.googleapis.com/css?family=Roboto',
    'https://fonts.googleapis.com/css?family=Monoton',
    'http://silada.konaweselatankab.go.id/assets/css/bootstrap.min.css',
    'http://silada.konaweselatankab.go.id/assets/css/atlantis.min.css'
  ]
}

Vue.use(VueHtmlToPaper, options);


// LIST NAVBAR DINAS




// LIST NAVBAR DINAS




Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
